import * as React from 'react'
import { FC, useCallback, useState, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { INotification } from '@user/store/notifications/typings'
import { toggleNotification } from '@user/store/notifications/api'
import { NotificationCard } from '.'

import Button from '@mui/material/Button'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

export const InternalNotification: FC<{
  notification: INotification
  setToEdit: (notif: INotification) => void
}> = ({ notification, setToEdit }) => {
  const {
    id,
    notificationEventName: name,
    helperText,
    isEnabled,
    salesTeamHierarchy: { salesTeamIds, salesTeamPositions },
    additionalEmailIds,
  } = notification

  const dispatch = useAppDispatch()

  const isSetUp = useMemo(
    () =>
      additionalEmailIds.length > 0 ||
      salesTeamIds.length > 0 ||
      salesTeamPositions.length > 0,
    [additionalEmailIds, salesTeamIds, salesTeamPositions],
  )

  const onClick = useCallback(
    () => setToEdit(notification),
    [notification, setToEdit],
  )

  const [loading, setLoading] = useState(false)
  const onChange = useCallback(async () => {
    setLoading(true)
    await dispatch(toggleNotification(id))
    setLoading(false)
  }, [dispatch, id])

  return (
    <NotificationCard
      type="Internal"
      name={name}
      helperText={helperText}
      rightContent={
        isSetUp ? (
          <Button
            color="primary"
            variant="outlined"
            onClick={onClick}
            data-test-id="manageNotificationBtn"
          >
            Manage
          </Button>
        ) : (
          <Button color="primary" variant="contained" onClick={onClick}>
            Set up Notification
          </Button>
        )
      }
      bottomContent={
        isSetUp && (
          <FormControlLabel
            label="Off/On"
            disabled={loading}
            control={<Switch checked={isEnabled} onChange={onChange} />}
          />
        )
      }
    />
  )
}
InternalNotification.displayName = 'InternalNotification'
